module.exports = __webpack_public_path__ + "static/media/35_A.20508bf7.png";